export const FORTRESS_GUARDIAN = 'FortressGuardian';
